import type { ComponentType, FC, PropsWithChildren, ReactChild } from 'react';
import React from 'react';

import type { NodeViewRenderers } from './../../ricos-types';
import type { Decorators } from './../../ricos-viewer-next/ContentViewer/rericos/decorators/nodeViewDecorators';

type ContentTraverserContextProps = {
  nodeViewDecorators: Decorators<JSX.Element>;
  renderers: NodeViewRenderers;
  SpoilerViewerWrapper?: ComponentType<{ className: unknown; width?: number }>;
  children: ReactChild;
};

type ContextType = {
  nodeViewDecorators: Decorators<JSX.Element>;
  renderers: NodeViewRenderers;
  SpoilerViewerWrapper?: ComponentType<
    PropsWithChildren<{ className: unknown; width?: number; type?: string; componentData?: object }>
  >;
};

export const ContentTraverserContext = React.createContext<ContextType>(
  null as unknown as ContextType
);

export const ContentTraverserContextProvider: FC<ContentTraverserContextProps> = ({
  nodeViewDecorators,
  renderers,
  SpoilerViewerWrapper,
  children,
}) => {
  return (
    <ContentTraverserContext.Provider
      value={{ nodeViewDecorators, renderers, SpoilerViewerWrapper }}
    >
      {children}
    </ContentTraverserContext.Provider>
  );
};
